import { render, staticRenderFns } from "./add-task-form.vue?vue&type=template&id=63c9915e&"
import script from "./add-task-form.vue?vue&type=script&lang=ts&"
export * from "./add-task-form.vue?vue&type=script&lang=ts&"
import style0 from "./add-task-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports